var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.255 3.172c-5.729-0.13-10.813 3.661-12.313 9.193 0.068-0.026-0.073 0.016 0 0-5.167 3.401-5.229 10.812-0.328 14.589l0.005-0.010-0.010 0.042c1.568 1.182 3.474 1.813 5.438 1.807h6.896l0.042 0.036h6.922c8.917 0.073 12.5-11.469 5.115-16.464-0.635-2.349-1.943-4.458-3.76-6.068l-0.057 0.057 0.005-0.068c-2.203-1.943-5.021-3.047-7.953-3.115zM15.776 8.703c1.656-0.057 3.359 0.49 4.646 1.531 1.609 1.344 2.526 3.344 2.484 5.438v0.693c4.708-0.094 4.708 7.016 0 6.922h-6.922l-0.010 0.010v-0.052h-6.927c-0.49 0-0.974-0.104-1.422-0.307-2.203-0.995-2.729-3.891-1.021-5.604 1.714-1.708 4.604-1.182 5.604 1.021l4.016-4.016c-1.333-1.74-3.26-2.932-5.411-3.354 0.026-0.010 0.052-0.031 0.073-0.026 1.26-1.385 3.026-2.198 4.896-2.255z",
    id: "path2",
    style: {
      fill: "#272627",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.1e04fae283cf14a5fd8da56247df2588.svg";
export { ForwardRef as ReactComponent };